import RichTextHeadline from 'components/shared/RichTextHeadline/RichTextHeadline';
import { cn, getColorway, getYMargins, getRoundedCornersBox } from 'utils/styles';
import { FaqClassNames, FaqProps } from './types';
import Schema from 'components/shared/Schema/Schema';
import { getRichTextValue, getColorwayName } from 'utils/formatters';
import ToggleMenu from './ToggleMenu';
import { liveUpdateAttrs } from 'libs/contentful/utils';
import { Margins } from 'types/constants';

export const Faq = ({
  sys,
  variant,
  sectionName,
  color,
  headline,
  toggleItems,
  margins = Margins.Centered,
  roundedCorners,
}: FaqProps) => {
  const toggleItemsList = toggleItems?.items ?? [];

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: toggleItemsList.flatMap(toggleItem =>
      (toggleItem.contentCollection?.items ?? []).map(accordionItem => ({
        '@type': 'Question',
        name: accordionItem.accordionLabelRte ? getRichTextValue(accordionItem.accordionLabelRte) : '',
        acceptedAnswer: {
          '@type': 'Answer',
          text: accordionItem.accordionCopy ? getRichTextValue(accordionItem.accordionCopy) : '',
        },
      })),
    ),
  };

  const internalClassNames: FaqClassNames = {
    outerWrapper: cn(getYMargins(margins), getColorway(color), getRoundedCornersBox(roundedCorners)),
    // Owns the spacing between the headline and the toggle menu via `gap` so it collapses
    // automatically when there's no headline (a single child has no gap).
    innerWrapper: cn('content-wrapper', 'flex flex-col gap-6 md:gap-14'),
    headline: cn('font-sans font-semibold text-heading-md md:text-heading-lg'),
  };

  return (
    <section
      {...(sectionName != null && { id: encodeURIComponent(sectionName) })}
      className={internalClassNames.outerWrapper}>
      {jsonLd && <Schema jsonLd={jsonLd} />}
      <div className={internalClassNames.innerWrapper}>
        {headline && (
          <div className={internalClassNames?.headline} {...liveUpdateAttrs(sys?.id, 'headline')}>
            <RichTextHeadline headline={headline} />
          </div>
        )}
        <ToggleMenu toggleItems={toggleItemsList} sys={sys} color={getColorwayName(color)} variant={variant} />
      </div>
    </section>
  );
};

export default Faq;
